/* eslint-disable n/no-unsupported-features/node-builtins -- this is a browser environment */
import { useEffect } from 'react'

import { isSafeInternalPath } from './redirectSafety'

export const REFERRER = 'referrer'

const KnownReferrerKeywords = ['portal', 'spa', 'ssa'] as const
type KnownReferrerKeyword = (typeof KnownReferrerKeywords)[number]

const isKnownKeyword = (value: string): value is KnownReferrerKeyword =>
  (KnownReferrerKeywords as readonly string[]).includes(value)

const portalRedirectPath = encodeURIComponent('/portal/welcome')
const pwaRedirectPath = encodeURIComponent('/account/welcome')

export const hasReferrer = () => !!localStorage.getItem(REFERRER)
export const getSignedInPath = (): string | null => {
  const referrer = localStorage.getItem(REFERRER)
  if (!referrer) {
    return null
  }
  switch (referrer) {
    case 'portal':
      return '/portal/'
    case 'spa':
      return '/servicepoint/'
    case 'ssa':
      return '/servicepoint-self-scan/'
    default:
      // Enable deeplink redirecting, but only to same-origin absolute paths to
      // prevent open-redirect / javascript: URI XSS via a crafted ?referrer=...
      return isSafeInternalPath(referrer) ? referrer : null
  }
}

export const getVerificationRedirectPath = () => {
  switch (localStorage.getItem(REFERRER)) {
    case 'portal':
      return portalRedirectPath
    default:
      return pwaRedirectPath
  }
}

export const useReferrer = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    if (!params.has(REFERRER)) {
      return
    }
    const value = params.get(REFERRER)!
    // Only persist values we will actually consume later: a known keyword or a
    // safe same-origin path. This prevents a crafted link from poisoning
    // localStorage with an attacker-controlled redirect target.
    if (isKnownKeyword(value) || isSafeInternalPath(value)) {
      // Putting referrer in local storage, so even with a refresh the user goes to the expected system
      // In the future we might also want some smarter routing based on the token of the user, but that
      // logic should not be implemented in the account-app
      localStorage.setItem(REFERRER, value)
    }
  }, [])
}
